module.exports = __webpack_public_path__ + "media/team/Aren-Thumbnail-66aa6889.png";